import { render, staticRenderFns } from "./InformationListAccordion.vue?vue&type=template&id=24961cac&"
import script from "./InformationListAccordion.vue?vue&type=script&lang=js&"
export * from "./InformationListAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports